module.exports = __webpack_public_path__ + "img/4-(8).7b0b0e50.jpg";